import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'

export const mockRalphOracle = {
  country: 'GBR',
  content: [
    '---',
    'version: v7',
    '---',
    '# Validation guidance',
    '',
    '## Eligible Entity Types',
    '',
    'Guidance for validating organisations in the United Kingdom.',
    '',
    '---',
    '',
    '## Reference Standards',
    '',
    '- Charity Commission register'
  ].join('\n')
}

export const ralphOracleHandlers = [
  rest.get(`${config.urls.api}v1/admin/ralph/oracle/:country`, (req, res, ctx) =>
    res(ctx.status(200), ctx.json({ ...mockRalphOracle, country: req.params.country }))
  )
]
